import { createAsyncThunk } from '@reduxjs/toolkit';
import GetEntriesFiltersService from 'modules/inbound/entries/application/NextHours/GetEntriesFiltersService';

const getEntriesST12Filters = createAsyncThunk(
  'entriesST12Filters/getEntriesFilters',
  async () => {
    const response = await GetEntriesFiltersService.execute();
    return response;
  }
);

export { getEntriesST12Filters };
